// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "us-east-2",
    "aws_cognito_identity_pool_id": "us-east-2:07691c1f-1561-4867-980a-4e0c913683fe",
    "aws_cognito_region": "us-east-2",
    "aws_user_pools_id": "us-east-2_42zfwMgTE",
    "aws_user_pools_web_client_id": "669uurhjne9tvlbhq9dn8rbtio",
    "oauth": {
        "domain": "stgconnectedtechcps.auth.us-east-2.amazoncognito.com",
        "scope": [
            "phone",
            "email",
            "openid",
            "profile",
            "aws.cognito.signin.user.admin"
        ],
        "redirectSignIn": "https://stg.connectedtechcps.com/waitsignin",
        "redirectSignOut": "https://stg.connectedtechcps.com/",
        "responseType": "code"
    },
    "federationTarget": "COGNITO_USER_POOLS",
};


export default awsmobile;
